import { Subscription } from '@dtx-company/inter-app/src/types/subscription'
import {
  UseSubscriptionResponse,
  useCurrentSubscriptionSWR
} from '@dtx-company/inter-app/src/hooks/useCurrentSubscriptionSWR'
import { useEffect, useState } from 'react'

export function usePlanPurchaseExperienceSubscriptionInfo(): {
  currentSubscriptionInfoSWR: UseSubscriptionResponse
  currentSubscriptionInfoData: Subscription | null | undefined
  isLoading?: boolean
} {
  const [isLoading, setIsLoading] = useState(false)
  const [currentSubscriptionInfoData, setCurrentSubscriptionInfoData] = useState<
    Subscription | undefined | null
  >(undefined)

  const currentSubscriptionInfoSWR = useCurrentSubscriptionSWR(
    {},
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true
    }
  )

  // treat current subscription info data as stale during revalidation so it doesn't change to undefined
  // when the user's token changes
  useEffect(() => {
    if (currentSubscriptionInfoSWR.data !== undefined) {
      setCurrentSubscriptionInfoData(currentSubscriptionInfoSWR.data)
    }
    setIsLoading(currentSubscriptionInfoSWR.isValidating || currentSubscriptionInfoSWR.isLoading)
  }, [
    currentSubscriptionInfoSWR.data,
    currentSubscriptionInfoSWR.isLoading,
    currentSubscriptionInfoSWR.isValidating
  ])

  return { currentSubscriptionInfoSWR, currentSubscriptionInfoData, isLoading }
}
